import React from 'react';
import { LicenseData } from './../../subscriptions/types/licenses.d';
import useLicenses from '../../subscriptions/hooks/useLicenses';

const useUserLicense = (uuid: string): { license: LicenseData | undefined; isLoading: boolean } => {
  const { licenses, isLoading } = useLicenses();

  const license = React.useMemo(() => {
    if (!!licenses) {
      return licenses.find((license) => license.assigned_to === uuid);
    }
  }, [licenses, uuid]);

  return { license, isLoading };
};

export default useUserLicense;
